'use client'

import React, { useRef } from 'react';
import './style.css';


const BookingSummaryBottomSheet = ({ children, ...props }: any) => {

    const {
        showGeneralBottomSheet,
        setShowGeneralBottomSheet,
        headingText
    } = props;

    const overlayContainerRef = useRef(null);
    const bottomSheetRef = useRef(null);

    const handleFBSCloseOnOutsideClick = (e) => {
        if (
            overlayContainerRef.current &&
            overlayContainerRef.current.contains(e.target) &&
            bottomSheetRef.current &&
            !bottomSheetRef.current.contains(e.target)
        ) {
            closeBottomSheet();
        }
    }

    function closeBottomSheet() {
        setShowGeneralBottomSheet(false);
    }

    return (
        <div
            className={`${showGeneralBottomSheet ? 'bsbs-visible' : 'bsbs-invisible'} bsbs-overlay`}
            ref={overlayContainerRef}
            onClick={handleFBSCloseOnOutsideClick}
        >
            <div
                className='bsbs'
                ref={bottomSheetRef}
            >
                <div
                    className='bsbs-heading-container'
                >
                    <div className='bsbs-heading'>
                        {headingText}
                    </div>
                    <div
                        className='close-bsbs-icon-container'
                        onClick={closeBottomSheet}
                    >
                        <img
                            className='close-bsbs-icon'
                            src='/images/closeGray.png'
                        />
                    </div>
                </div>

                {children}
            </div>
        </div>
    )
}

export default BookingSummaryBottomSheet; 